import React from 'react';
import { Route, Switch } from 'wouter';
import { BoardLoginPage } from './BoardLoginPage';
import { CreateOrganizationPage } from './CreateOrganizationPage';
import { DirectInvitePage } from './DirectInvitePage';
import { JoinOrganizationPage } from './JoinOrganizationPage';
import { LoginPage } from './LoginPage';
import { OAuthConsentPage } from './OAuthConsentPage';
import { OrganizationsPage } from './OrganizationsPage';
import { RegisterPage } from './RegisterPage';

export const AppSwitch = () =>
    <Switch>
        <Route path="/login/register" component={RegisterPage} />
        <Route path="/login" component={LoginPage} />
        <Route path="/auth/consent" component={OAuthConsentPage} />
        <Route path="/organizations" component={OrganizationsPage} />
        <Route path="/organizations/create" component={CreateOrganizationPage} />
        <Route path="/organizations/join" component={JoinOrganizationPage} />
        {/* Aliases for the app-server entry/redirect routes. */}
        <Route path={/^\/BO\w+$/} component={BoardLoginPage} />
        <Route path="/direct-invite/:inviteId" component={DirectInvitePage} />
        <Route>
            <div>Hello World</div>
        </Route>
    </Switch>;
